// admin-analytics-expansion P3b (design D6/D7) — Ticket Detail route
//
// Access: org_admin + supervisor (mirrors ticket-browse/analytics gating).
// Server is the real authority (each endpoint independently enforces role +
// location scope via assert-location-scope.ts); this is a UX gate only.
//
// NOTE: .index.tsx suffix REQUIRED (same convention as the browse/history
// ticket routes).

import { useTranslation } from '@jq4race/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { ShieldOff } from 'lucide-react';

import { getCurrentSession } from '../app/auth-state';
import { PageHeader } from '../modules/app-shell/ui/PageHeader';
import { TicketDetailPage } from '../modules/tickets/ui/pages/TicketDetailPage';

const ALLOWED_ROLES = ['org_admin', 'supervisor'];

function TicketDetailRouteComponent() {
  const session = getCurrentSession();
  const role = session?.user.role ?? '';

  if (!ALLOWED_ROLES.includes(role)) {
    return <DeniedPage />;
  }

  return <TicketDetailPage />;
}

function DeniedPage() {
  const { t } = useTranslation('tickets');
  return (
    <div className="space-y-8">
      <PageHeader eyebrow={t('page.eyebrow')} title={t('page.detailTitle')} />
      <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
        <ShieldOff className="h-10 w-10 text-jq-stone" strokeWidth={1.25} />
        <p className="text-[14px] font-medium text-jq-charcoal">
          You do not have permission to view ticket details.
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/tickets/$ticketId/')({
  component: TicketDetailRouteComponent,
  staticData: {
    breadcrumb: ['Tickets', 'Ticket Detail'],
  },
});
